import * as hankoWebAuthn from "../index";
(globalThis as any).hankoWebAuthn = hankoWebAuthn;
